import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";
import Lodinging from "../components_root/loading";
import Loadingimg from '../components_root/loadingimg';
import { googleLogout, checkUserAuth } from '../firebase';
//page links  
import { VscVmConnect, VscLock, VscCloudDownload, VscEdit, VscGistSecret, VscCallIncoming, VscLocation, VscBriefcase, VscCalendar, VscMail } from "react-icons/vsc";
import Photosicon from '../assets/photos_icon.png';
import ShareButton from '../components_root/ShareButton';
 import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import Select_yes_no from '../components_root/select_yes_no.jsx';
import { MdAccountBox, MdEdit, MdEmail, MdNightsStay, MdOutlineLightMode, MdSupport } from 'react-icons/md';
export default function Account() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [accountname, setaccountname] = useState("");
  const [guid, setguid] = useState('');
  const [ProfileProgress, setProfileProgress] = useState(20);
 
  const [isLoading, setIsLoading] = useState(false);
  const [accountstatus, setAccountstatus] = useState(false);
  const [Usersloginlist, setUsersloginlist] = useState([]);
  const popupRef = useRef(null);
  const [islogin, setIslogin] = useState(false);
  const [Selected, setSelected] = useState('Profile');
  const [accountdata, setAccountdata] = useState([]);
  useEffect(() => {
    const existingsessiontoken = Cookies.get("sessiontoken");
    if (existingsessiontoken !== null && existingsessiontoken !== undefined) {
      setguid(Cookies.get("guid"));
    }
  }, [navigate]);
  const handleGoogleLogout = async () => {
    setIsLoading(true);
    await googleLogout();
    setUser(null);
  };

  useEffect(() => {
    const checkIntegration = async () => {
      try {
        const checkQuery = query(
          collection(db, "accounts"),
          where("guid", "==", guid)
        );

        const checkSnap = await getDocs(checkQuery);

        if (checkSnap.empty) {
           await googleLogout();
          navigate('/');
          return;
        }

        const dataList = checkSnap.docs.map(doc => ({
          uid: doc.id,
          ...doc.data()
        }));

        setAccountdata(dataList);
        if (dataList.length > 0) {
          setAccountstatus(dataList[0].status);
        }

      } catch (err) {
        console.error("Error checking API integration:", err);
      }
    };

    if (guid) {
      checkIntegration();
    }
  }, [guid, navigate]);

  
    
    const [darkMode, setDarkMode] = useState(false); 
  useEffect(() => {
    const savedTheme = Cookies.get("theme");
    if (savedTheme === "dark") {
      setDarkMode(true);
      document.body.classList.add("dark-theme");
    }
  }, []);

  const toggleTheme = () => {
    setDarkMode((prev) => {
      const newMode = !prev;
      if (newMode) {
        document.body.classList.add("dark-theme");
        Cookies.set("theme", "dark", {
          expires: 365,
          path: "/", 
          domain: ".viabig.com", // use only on live site
          secure: true
        });
      } else {
        document.body.classList.remove("dark-theme");
        Cookies.set("theme", "light", {
          expires: 365,
          path: "/", 
          domain: ".viabig.com",
          secure: true
        });
      }
      return newMode;
    });
};


  return (
    <div>
      <Header />

      <div className="container_roots">
        <Helmet>
          <title>btcpayai - Simplify HR, Payroll & Accounting - All in One Platform</title>

          <meta name="description" content="btcpayai is a trusted enterprise platform for managing HR, payroll, and accounting operations with simplicity and precision." />
          <meta name="keywords" content="btcpayai, HR software, payroll software, accounting software,Google cloud, enterprise HR, workforce management, employee platform, financial tools, btcpayai platform" />
          <meta name="author" content="btcpayai.com" />
          <meta name="robots" content="index, follow" />

          <meta property="og:title" content="btcpayai – HR, Payroll & Accounting Platform" />
          <meta property="og:description" content="Discover btcpayai – the all-in-one platform to manage human resources, payroll, and accounting for your business." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.btcpayai.com" />
          <meta property="og:image" content="https://www.btcpayai.com/images/btcpayai.png" />
        </Helmet>
        <div className="container_size">
          <div className='post-container'>
            <div className='post_div'>
              <div className='contact-title-div'>
                <div className="contact-title">Account Settings</div>
              </div>
              <div className='contact-title-div'>
                <table className='table_padding' >
                  <tr>
                    <td >
                      Name
                    </td>
                    <td><div className='contact-header bold'>
                      <input
                        type="text"
                        className="input bold"
                        maxLength={20}
                        placeholder="Enter account name"
                        value={accountname || accountdata[0]?.name}
                        onChange={(e) => setaccountname(e.target.value)}
                      />
                    </div></td>
                    <td><MdEdit className='icon'/>
                    </td>
                  </tr>
                     <tr>
                    <td >
                     Theme
                    </td>
                    <td>Switch between day (light) and night (dark) themes for comfortable viewing anytime.</td>
                   
<td>
  <div onClick={toggleTheme} className="button-ui">
    {darkMode ? (
      <>
        <MdOutlineLightMode className="icon" /> Day
      </>
    ) : (
      <>
        <MdNightsStay className="icon" /> Night
      </>
    )}
  </div>
</td>
                  
                  </tr>
                    <tr>
                    <td >
                      Guid
                    </td>
                    <td><div className='contact-header'> <a> {accountdata[0]?.email || ""}</a> </div></td>
                    <td>
                    </td>
                  </tr>
                  <tr>
                    <td >
                      Account
                    </td>
                    <td> <div className='contact-header'>Status <b> {accountstatus === true ? "Activate" : "Deactivate"}</b> </div></td>
                    <td >
                      <Select_yes_no
                        checked={accountstatus}
                        onChange={(e) => { }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td >
                      Guid
                    </td>
                    <td><div className='contact-header'> <a> {accountdata[0]?.guid || ""}</a> </div></td>
                    <td>
                    </td>
                  </tr>
                    <tr>
                    <td >
                    Currency 
                    </td>
                    <td><div className='contact-header'> <a> {accountdata[0]?.currency_code || "USD"}</a> </div></td>
                   <td><MdEdit className='icon'/>
                    </td>
                  </tr>
                  <tr>
                    <td className='contact-details'>Create</td>
                 <td>
{accountdata?.[0]?.date_time?.toDate?.()
  ? accountdata[0].date_time.toDate().toLocaleString()
  : "N/A"}
</td>
                    <td></td>
                  </tr>
                  
                  <tr>

                    <td> <div className='contact-header'> <a>User</a> </div></td>
                    <td></td>

                 <td width={100}>
  <div
    className="button-ui account-btn"
    onClick={!isLoading ? handleGoogleLogout : undefined}
    style={{ cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
  >
    {isLoading ? <Loadingimg /> : <VscLock className="icon" />}
    Logout
  </div>
</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
      <Footers/>
      <Navbar />
    </div>

  );
}
